import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class PagesFaqs extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: "1",
    };
    this.toggleTab = this.toggleTab.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>FAQs</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Dashboard" breadcrumbItem="FAQs" />

            <div className="checkout-tabs">
              <Row>
                <Col lg="2">
                  <Nav className="flex-column" pills>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "1",
                        })}
                        onClick={() => {
                          this.toggleTab("1");
                        }}
                      >
                        <i className="bx bx-question-mark d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">
                          General Questions
                        </p>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "2",
                        })}
                        onClick={() => {
                          this.toggleTab("2");
                        }}
                      >
                        <i className="bx bx-check-shield d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">Privacy Policy</p>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "3",
                        })}
                        onClick={() => {
                          this.toggleTab("3");
                        }}
                      >
                        <i className="bx bx-support d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">Support</p>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Col>
                <Col lg="10">
                  <Card>
                    <CardBody>
                      <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                          <CardTitle className="mb-5 h4">
                            General Questions
                          </CardTitle>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              What is DigiLab ?
                              </h5>
                              <p className="text-muted">
                              Digi Lab is an Internet-based website and smartphone-enabled application that will bring several registered laboratories of Pakistan under a single marketplace for online test scheduling, home sampling, report tracking and financial assistance for patients
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              Why do we use it ?
                              </h5>
                              <p className="text-muted">
                              DigiLab was made to meet the needs of patients who are often unaware of the available options for getting economical and quality diagnostics and testing
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How will I get my reports ?
                              </h5>
                              <p className="text-muted">
                              You will get your reports on your registered email address and you can also download it from your account
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How to get Financial Aid?
                              </h5>
                              <p className="text-muted">
                              You will get an option to request financial aid for a test during payment by providing relevant information, and our staff will review your request and accept or reject it based on the information provided.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                                How to avail Home Sampling?
                              </h5>
                              <p className="text-muted">
                               You will get an option to request homesampling while booking the test
                              </p>
                            </Media>
                          </Media>
                        </TabPane>
                        <TabPane tabId="2">
                          <CardTitle className="mb-5">Privacy Policy</CardTitle>

                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              What information will you be collecting ?
                              </h5>
                              <p className="text-muted">
                              Only basic information required for conducting the test and making the report will be collected. We will not be collecting any information that is not required for the test.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How will you use the data you collected ?
                              </h5>
                              <p className="text-muted">
                              We will use the data to provide you with the best possible service and to improve our services. We will not share your data with any third party.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How will you protect my data ?
                              </h5>
                              <p className="text-muted">
                              We will use the best possible security measures to protect your data. We will not share your data with any third party.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              Are payments made through DigiLab secure ?
                              </h5>
                              <p className="text-muted">
                              Yes, all payments made through DigiLab are secure and encrypted.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                               How long will you keep my data ?
                              </h5>
                              <p className="text-muted">
                              We will keep your data for as long as you are using our services. Once you stop using our services and delete your account, we will delete your data.
                              </p>
                            </Media>
                          </Media>
                        </TabPane>
                        <TabPane tabId="3">
                          <CardTitle className="mb-5">Support</CardTitle>

                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How can we contact the customer support?
                              </h5>
                              <p className="text-muted">
                              You can contact our customer support by sending a message through the contact us page.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How long will it take to get a response from the customer support?
                              </h5>
                              <p className="text-muted">
                              Our customer support is available 24/7. You can contact us at any time.
                                
                              </p>
                            </Media>
                          </Media>

                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How can I get my report ?
                              </h5>
                              <p className="text-muted">
                              You will get your report through email after the test is completed.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              How long will it take to resolve complaints?
                              </h5>
                              <p className="text-muted">
                              We will try to resolve your complaints as soon as possible. We will try to resolve your complaints within 24 hours.
                              </p>
                            </Media>
                          </Media>

                          <Media className="faq-box">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                              What time is the customer support available?
                              </h5>
                              <p className="text-muted">
                              Our customer support is available 24/7. You can contact us at any time.
                              </p>
                            </Media>
                          </Media>
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default PagesFaqs;
